import { axiosApi } from '@/api/axios';

export default {
  index(params) {
    return axiosApi.get('/user_notifications', { params });
  },
  update(id, seen) {
    return axiosApi.patch(`/user_notifications/${id}/seen`, { seen });
  },
  updateAll() {
    return axiosApi.patch('/user_notifications/read_all');
  },
  unreadNotificationsCount() {
    return axiosApi.get('/user_notifications/unseen');
  },
};
